<template>
  <KeyValuePair
    :label="accessorialName"
    :value="
      renderMoney(accessorial.charge, {
        currencyCode,
      })
    "
    inline
  />
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { computed, toRef, toRefs } from 'vue';

import { renderMoney } from '@rygen/rygen-ui/i18n';
import { Currency } from '@rygen/rygen-ui/model';

import { RateQuoteAccessorial } from '@/model';
import { useParentEntityStore } from '@/stores/ParentEntity';

import KeyValuePair from '@rygen/rygen-ui/components/ui/KeyValuePair.vue';

const props = defineProps({
  accessorial: {
    type: RateQuoteAccessorial,
    default: () => new RateQuoteAccessorial(),
  },
  currencyCode: {
    type: String as PropType<Currency>,
    default: () => Currency.USD,
  },
});
const { accessorial, currencyCode } = toRefs(props);

const { parentEntity } = useParentEntityStore();

const stops = toRef(() => parentEntity.value?.stops ?? []);

const stopName = computed(() => {
  const seqNumber = accessorial.value.stopSequenceNumber;
  const stop = stops.value.find((s) => s.sequenceNumber === seqNumber);
  return stop?.stopLabel ?? '';
});

const accessorialName = computed(() => {
  const codeName = accessorial.value.code?.name;
  return `${codeName} ${stopName.value ? `(${stopName.value})` : ''}`;
});
</script>
